/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";
import { Route, Routes, useParams } from "react-router-dom";
import * as Actions from './store/actions';
import { useDispatch } from "react-redux";
import { ItineraryFull } from "./atom/Types";
import { GET_ITINERARY_FULL } from "./graphQL/queries";
import { useLazyQuery } from "@apollo/client";
import React from "react";
import Loader from "./components/tripOverview/Common/Loader";
import Overview from "./components/tripOverview/overview";

const ShareRouterConfig = () => {
    const { id } = useParams();
    const dispatch = useDispatch()
    const [getItineraryData, { data: ItineraryData, refetch: getItineraryRefetch, loading: Itineraryload }] = useLazyQuery<ItineraryFull>(GET_ITINERARY_FULL, {
        variables: { key: "" }
    });


    const encodingData = () => {
        if (id) {
            let decodedData = atob(id)


            if (decodedData) {
                let split: string[] = decodedData.split('&')


                if (split[0].startsWith("share")) {
                    let type = split[0].split('=')
                    dispatch(Actions.ShareType(type[1]))

                }
                if (split[1]?.startsWith("id") || split[2]?.startsWith("tid")) {
                    let id: string[] = []
                    if (split[1]?.startsWith("id"))
                        id = split[1].split('=')
                    else if (split[2]?.startsWith("tid"))
                        id = split[2].split('=')


                    if (id[1]) {
                        getItineraryData({
                            variables: { key: id[1] }
                        }).then((b) => {
                            if (b.error) {
                                throw b.error.message;
                            }
                        }).catch(() => {


                        })
                    }
                }
                if (split[2]?.startsWith("copy")) {
                    let type = split[2].split('=')
                    dispatch(Actions.ShareRenameID(type[1]))

                }
            }
        }
    }
    useEffect(() => {
        encodingData()
    }, [])
    return <div>
        {(ItineraryData && ItineraryData?.queryItinerary?.length > 0 && !Itineraryload) ? <div>
            <Routes>
                <Route
                    path="/"
                    element={<React.Suspense fallback={<Loader content='Loading...' />}>
                        <Overview BuilderData={ItineraryData} getItineraryRefetch={getItineraryRefetch} loading={Itineraryload} />
                    </React.Suspense>} />
            </Routes>
        </div>
            : <div><Loader content='Loading...' /></div>}
    </div>
}

export default ShareRouterConfig